import { render, staticRenderFns } from "./zScrollLayout.vue?vue&type=template&id=af64d4c2&scoped=true&"
import script from "./zScrollLayout.vue?vue&type=script&lang=js&"
export * from "./zScrollLayout.vue?vue&type=script&lang=js&"
import style0 from "./zScrollLayout.vue?vue&type=style&index=0&id=af64d4c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af64d4c2",
  null
  
)

export default component.exports